'use strict';

import register from './core';
import '../functions/jquery-global.js';
import Jump from 'jump.js';

register('scroll-to-top', function (element) {
  var $button = $(element),
    viewPortHeight = window.innerHeight,
    $main = $('#main'),
    toggleClass = 'scroll-to-top--active',
    lastScrollTop = 0;

  $(window).on('scroll', function () { 
    var position = $(this).scrollTop(),
      enabledHeight = viewPortHeight * 3;

    if (position > lastScrollTop && position > enabledHeight) {
      $button.addClass(toggleClass);
    }
    else if (position === lastScrollTop) { //Required to please IE
      
    }
    else {
      if (position < 200) {
        $button.removeClass(toggleClass);
      }
    }
    lastScrollTop = position;
  }); 

  $button.on('click', function () {
    $button.removeClass(toggleClass);
    Jump('body', {
      duration: 1000
    });
  });
});
